<div *ngIf="(chartLines$ | async) === undefined" class="container flex-column center middle full-width full-height">
    <mat-spinner strokeWidth="3" [diameter]="50"></mat-spinner>
</div>

<report class="full-height report" *ngIf="(chartLines$|async) && (chartLines$|async)!==(null||undefined)" [orientation]="'landscape'"
    title="Fragmentation Camera Aggregated Report">
    <div controls>
        <div>
            <mat-form-field class="full-width">
                <mat-label>Duration</mat-label>
                <mat-select [value]="duration$ | async" [disabled]="(chartLines$ | async) === undefined"
                    (valueChange)="duration$.next($event)">
                    <mat-option *ngFor="let opt of durationOptions|async; let index = index" [value]="opt.key">
                        {{ opt.label }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <ng-container *ngIf="(duration$ | async) === 'shifts'">
            <mat-form-field class="full-width">
                <mat-label> Shift </mat-label>
                <mat-select [disabled]="(chartLines$ | async) === undefined" [value]="shift$ | async" (valueChange)="shift$.next($event)" >
                    <mat-option *ngFor="let shift of shifts$ | async" [value]="shift">
                        {{ shift.title }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
        <ng-container *ngIf="(duration$ | async) === 'custom'">
            <div>
                <mat-form-field class="full-width">
                    <mat-label>Start Date</mat-label>
                    <date-picker [disabled]="(chartLines$|async)===undefined" [value]="begin$ | async"
                        (valueChange)="begin$.next($event)">
                    </date-picker>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="full-width">
                    <mat-label>End Date</mat-label>
                    <date-picker [disabled]="(chartLines$|async)===undefined" [value]="end$ | async"
                        (valueChange)="end$.next($event)">
                    </date-picker>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="full-width">
                    <mat-label>Start Time</mat-label>
                    <time-picker [disabled]="(chartLines$|async)===undefined" [value]="begin$|async"
                        (valueChange)="begin$.next($event)">
                    </time-picker>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="full-width">
                    <mat-label>End Time</mat-label>
                    <time-picker [disabled]="(chartLines$|async)===undefined" [value]="end$|async"
                        (valueChange)="end$.next($event)">
                    </time-picker>
                </mat-form-field>
            </div>
        </ng-container>
        <ng-container *ngIf="(duration$ | async) === 'week'">            
            <mat-form-field class="full-width">
                <mat-label>Enter a date range</mat-label>
                <mat-date-range-input [rangePicker]="picker" [disabled]="(chartLines$ | async) === undefined">
                    <input matStartDate [value]="defaultDateRange?.start" placeholder="Start date">
                    <input matEndDate [value]="defaultDateRange?.end" placeholder="End date">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>            
        </ng-container>
    </div>
    <ng-container pages>
        <report-page-title ngProjectAs="report-page" title="Fragmentation Camera Aggregated Report">
        </report-page-title>
        <report-page-timeline ngProjectAs="report-page" [timelineData]="chartLines$|async" [startDate]="(timeRange$|async).begin"
        [endDate]="(timeRange$|async).end">
        </report-page-timeline>
        <app-custom-timeline-page ngProjectAs="report-page" [startDate]="(timeRange$|async).begin"
        [endDate]="(timeRange$|async).end">
        </app-custom-timeline-page>
        <oversize-rockcount-timeline-page ngProjectAs="report-page" [startDate]="(timeRange$|async).begin" [endDate]="(timeRange$|async).end">
        </oversize-rockcount-timeline-page>
        <app-quantity-timeline-page ngProjectAs="report-page" [startDate]="(timeRange$|async).begin"
        [endDate]="(timeRange$|async).end">
        </app-quantity-timeline-page>        
        <ng-container ngProjectAs="report-page" *ngIf="(this.fragQuery.timelineSieveSizesAtPercents$|async)">
            <report-page [footer]="true" class="landscape">
                <div class="full-height full-width flex-column">
                    <div class="full-width">
                        <div class="strip bar-1"></div>
                    </div>
                    <div class="full-height">
                        <div class="container">
                            <div *ngIf="(tags$ | async)?.length > 0">
                                <div class="text-center">
                                    <h1 class="font-large">Tag Details</h1>
                                </div>
                                <div>
                                    <live-tag-details [tags]="tags$ | async"></live-tag-details>
                                </div>
                                <hr>
                            </div>
                            <div class="text-center">
                                <h1 class="font-large">Rocks Details</h1>
                            </div>
                            <div class="flex-row justify full-width">
                                <div class="full-width">
                                    <card-square-blocks [title]="'Total ' + (quantityYAxisTitle$|async)" [warn]="false" [size]="'small'" [long]="true">
                                    <span>
                                        {{totalQuantity$|async}}
                                    </span>
                                    </card-square-blocks>
                                </div>
                                <div class="full-width" *ngIf="isTruck()">
                                    <card-square-blocks [title]="'Total No. of Trucks'" [warn]="false" [size]="'small'" [long]="true">
                                        <span>{{(this.fragQuery.timelineSieveSizesAtPercents$|async).totalIntervalCount}}</span>
                                    </card-square-blocks>
                                </div>
                                <ng-container *ngIf="(totalPayload$ | async) as totalPayload">
                                    <div class="full-width" *ngIf="totalPayload > 0">
                                        <card-square-blocks [title]="'Total Payload'" [warn]="false" [size]="'small'" [long]="true">
                                            <span>
                                                {{totalPayload$|async}} {{payloadUnitAbbr$|async}}
                                            </span>
                                        </card-square-blocks>
                                    </div>
                                </ng-container>
                                <div class="full-width" *ngIf="(actualPayload$ | async) as actualPayload">
                                    <ng-container *ngIf="actualPayload > 0">
                                        <card-square-blocks [title]="'Actual Payload'" [warn]="false" [size]="'small'" [long]="true">
                                            {{(actualPayload$|async)}} {{payloadUnitAbbr$|async}}
                                        </card-square-blocks>
                                    </ng-container>
                                </div>
                                <div class="full-width" *ngIf="isConveyor()">
                                    <mat-card  class="card-small long">
                                        <span>
                                            Rocks >
                                            <measurement class="titlespan" type="particleSize" [unitSystem]="(particleSizeUnitSystem$ | async)" [value]="slabDiameter"></measurement>
                                            (Slabs)
                                        </span>
                                        <div class="small-card-content primary">
                                            {{ slabs }}
                                        </div>
                                    </mat-card>
                                    </div>
                            </div>
                            <hr>
                            <div class="flex-row wrap around card-content-scroll">
                                <div class="oversized-rocks-content">
                                    <card-square-blocks [title]="'Oversized Rocks'" [warn]="false" [size]="'medium'" [long]="true">
                                        {{ (accumulatedData$ | async).totalOversizeRockCount}}
                                    </card-square-blocks>
                                </div>
                                <div *ngFor="let keys of (newPercents$ | async).keys(); let j = index">
                                    <card-square-blocks [title]="'D' + keys" [size]="'medium'" [warn]="false">
                                        <span>{{ (accumulatedData$ | async).data[j + 1] | unitConversion:  (particleSizeUnit$|async)}}</span>
                                    </card-square-blocks>
                                </div>
                            </div>
                        </div>
                        <div class="container">
                            <analysis-table [showDxxTable]="false" [size]="'small'" [direction]="'vertical'" [height]="'normal'"
                            [dxxArr]="this.tableDataMap.get('summary').dxxArr"
                            [dataArr]="this.tableDataMap.get('summary').dataArr"
                            [percentArr]="this.tableDataMap.get('summary').percentArr"
                            [primaryTableRows]="12"
                            [secondaryTableRows]="35"
                            (secondaryTables)="onTablesReceived($event)"
                            >
                            </analysis-table>
                        </div>
                    </div>
                    <div class="full-width">
                        <div class="strip bar-1"></div>
                        <div class="strip"></div>
                        <div class="strip"></div>
                    </div>
                </div>
            </report-page>
        </ng-container>
        <ng-container ngProjectAs="report-page" *ngFor="let chunk of this.cardTables |chunk: 4">
            <report-page [footer]="true" class="landscape">
                <div class="full-height full-width flex-column">
                    <div class="full-width">
                        <div class="strip bar-1"></div>
                    </div>
                    <div class="flex-row container psd-chart-container">
                        <div class="table-container" *ngFor="let table of chunk">
                            <ng-container *ngTemplateOutlet="table"></ng-container>
                        </div>
                    </div>
                    <div class="full-width">
                        <div class="strip bar-1"></div>
                        <div class="strip"></div>
                        <div class="strip"></div>
                    </div>
                </div>
            </report-page>
        </ng-container>
        <ng-container ngProjectAs="report-page">
            <report-page [footer]="true" class="landscape">
                <div class="full-height full-width flex-column">
                    <div class="full-width">
                        <div class="strip bar-1"></div>
                    </div>
                    <div class="container psd-chart-container">
                        <psd-chart [index]="0" [data]="[accumulatedData$|async]" [dxxLabels]="false"></psd-chart>
                    </div>
                    <div class="full-width">
                        <div class="strip bar-1"></div>
                        <div class="strip"></div>
                        <div class="strip"></div>
                    </div>
                </div>
            </report-page>
        </ng-container>
    </ng-container>
</report>